import { COLORS_CONFIG, COLORS_CONFIG_BAR } from '@components/widgets/apacheEchart/Commons'
import { answeredMapper, invalidMapper } from '../dashHelper'
import { getCommonWidget } from '../dashWidgetHelper'
import { commonWidgets, MITSUBISHI_SCALE_3_COLORS } from './commonWidgetsMitsu'

export default {
  title: 'Zonal Postventa Dashboard',
  description: 'Dashboard de Zonal Postventa',
  widgets: (filters: FiltersUI) => [
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'multipleTrendByMonth',
      title: 'widgets.npsPosventa',
      position: [0, 0],
      size: [1, 2],
      indicator: 'POSVENTA_NPS',
      criticalMomentId: 2,
      extras: {
        periods: 6
      },
      extraConfigs: {
        useCurrent: 0,
        colors: MITSUBISHI_SCALE_3_COLORS
      }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGeneric',
      title: 'widgets.snPosventa',
      position: [1, 0],
      size: [1, 2],
      indicator: 'POSVENTA_SATISFACCION',
      criticalMomentId: 2
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGenericByStatus',
      title: 'widgets.porcRespuestasPostventa',
      position: [2, 0],
      size: [1, 2],
      mapper: answeredMapper,
      url: 'survey-responses/values',
      criticalMomentId: 2
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'multipleGaugeByQuestion',
      title: 'widgets.customerJourneyPostventa',
      position: [0, 2],
      size: [4, 2],
      indicator: 'POSVENTA_CUSTOMER_JOURNEY',
      criticalMomentId: 2
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByQuestionBest',
      title: 'widgets.bestRotativasPostventa',
      position: [0, 4],
      size: [2, 2],
      indicator: 'POSVENTA_ROTATIVAS',
      criticalMomentId: 2
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByQuestionWorst',
      title: 'widgets.worstRotativasPostventa',
      position: [2, 4],
      size: [2, 2],
      indicator: 'POSVENTA_ROTATIVAS',
      criticalMomentId: 2
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByGeoBest',
      title: 'widgets.bestGeoLocationsPostventa',
      position: [0, 6],
      size: [2, 2],
      extraConfigs: {
        backgroundColor: '#501C78',
        titleBackgroundColor: '#88DD76'
      },
      indicator: 'POSVENTA_SATISFACCION',
      criticalMomentInclude: [2, 11703],
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByGeoWorst',
      title: 'widgets.worstGeoLocationsPostventa',
      position: [2, 6],
      size: [2, 2],
      extraConfigs: {
        backgroundColor: '#501C78',
        titleBackgroundColor: '#db7476'
      },
      indicator: 'POSVENTA_SATISFACCION',
      criticalMomentInclude: [2, 11703],
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByTagBest',
      title: 'widgets.bestTagsPostventa',
      position: [0, 8],
      size: [2, 2],
      indicator: 'sentiment',
      criticalMomentId: 2,
      extras: {
        trunc: 'HALF_DOWN',
        topSize: 3,
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByTagWorst',
      title: 'widgets.worstTagsPostventa',
      position: [2, 8],
      size: [2, 2],
      indicator: 'sentiment',
      criticalMomentId: 2,
      extras: {
        resultType: 'bottom',
        trunc: 'HALF_UP',
        bottomSize: 3,
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'textAnalysis',
      title: 'widgets.sentimentAnalysis',
      position: [0, 10],
      size: [4, 4],
      criticalMomentId: 2,
    }),
    {
      title: 'widgets.zoneGeneralSatisfaction',
      helpText: 'widgets.zoneGeneralSatisfaction',
      // [Column, Row]
      position: [0, 14],
      size: [4, 2],
      config: {
        id: 'satisfaction-zona',
        type: 'rankingIPN',
        indicators: [
          {
            indicator: 'POSVENTA_NPS',
            keyExtract: ['group', 'value', 'groupCount', 'position'],
            grouped: 'geoLocation',
            label: 'group',
            value: 'position',
            singleton: true,
            limit: 5,
            extras: {
              aggregation: 'rankingPosition',
              featureInclude: ['zoomOut'],
            },
          },
        ],
      },
    },
    {
      title: 'widgets.distributorGeneralSatisfaction',
      helpText: 'widgets.distributorGeneralSatisfaction',
      // [Column, Row]
      position: [0, 16],
      size: [4, 2],
      config: {
        id: 'satisfaccion-dist',
        type: 'bar',
        fillMode: '',
        //colors: '#f38625',
        colors: COLORS_CONFIG_BAR,
        showValues: true,
        decimals: 0,
        percentageScale: false,
        indicators: [
          {
            indicator: 'POSVENTA_SATISFACCION',
            grouped: 'geoLocation',
            keyExtract: ['group', 'value'],
            label: 'group',
            value: 'value',
            singleton: true,
            extras: {
              groupByLevel: 3,
              criticalMomentId: 2,
            },
          },
        ],
      },
    },
    {
      title: 'widgets.appointmentPostventa',
      helpText: 'widgets.appointmentPostventa',
      // [Column, Row]
      position: [0, 18],
      size: [2, 2],
      config: {
        id: 'posventa-puntualidad',
        type: 'pie',
        fillMode: '',
        colors: ['#015c52', '#33b9ce', '#f38625'],
        showValues: true,
        //percentageScale: false,
        mapper: (data) => {
          return data.map((item) => ({
            id: item['group'] == null ? 'Indefinido' : item['group'],
            label: item['group'] == null ? 'Indefinido' : item['group'],
            value: item['value'],
          }))
        },
        indicators: [
          {
            indicator: 'POSVENTA_AGENDAR_CITA',
            //grouped: 'geoLocation',
            keyExtract: ['group', 'count', 'value'],
            label: 'group',
            value: 'value',
            singleton: true,
            extras: {
              criticalMomentId: 2,
            },
          },
        ],
      },
    },
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGeneric',
      key: 'posventa-instalaciones',
      title: 'widgets.waitingRoomPostventa',
      helpText: 'widgets.waitingRoomPostventa',
      position: [2, 18],
      size: [1, 2],
      indicator: 'POSVENTA_INSTALACIONES',
      criticalMomentId: 2,
      extraConfigs: {
        maxValue: 5,
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGeneric',
      key: 'posventa-senaletica',
      title: 'widgets.signagePostventa',
      helpText: 'widgets.signagePostventa',
      position: [3, 18],
      size: [1, 2],
      indicator: 'POSVENTA_SENIALECTICA',
      criticalMomentId: 2,
      extraConfigs: {
        maxValue: 5,
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGeneric',
      key: 'posventa-facturacion',
      title: 'widgets.paymentPostventa',
      helpText: 'widgets.paymentPostventa',
      position: [0, 20],
      size: [1, 2],
      indicator: 'POSVENTA_FACTURACION',
      criticalMomentId: 2,
      extraConfigs: {
        maxValue: 5,
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGeneric',
      key: 'posventa-vehiculo-sustitucion',
      title: 'widgets.substitutionCarPostventa',
      helpText: 'widgets.substitutionCarPostventa',
      position: [1, 20],
      size: [1, 2],
      indicator: 'POSVENTA_VEHICULO_SUSTITUCION',
      criticalMomentId: 2,
      extraConfigs: {
        maxValue: 5,
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGeneric',
      key: 'posventa-limpieza-vehiculo',
      title: 'widgets.carStatusPostventa',
      helpText: 'widgets.carStatusPostventa',
      position: [2, 20],
      size: [1, 2],
      indicator: 'POSVENTA_LIMPIEZA_VEHICULO',
      criticalMomentId: 2,
      extraConfigs: {
        maxValue: 5,
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGeneric',
      key: 'posventa-reparacion',
      title: 'widgets.repairPostventa',
      helpText: 'widgets.repairPostventa',
      position: [3, 20],
      size: [1, 2],
      indicator: 'POSVENTA_REPARACION_VEHICULO',
      criticalMomentId: 2,
      extraConfigs: {
        maxValue: 5,
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGeneric',
      key: 'posventa-disponibilidad',
      title: 'widgets.repairAvailablePostventa',
      helpText: 'widgets.repairAvailablePostventa',
      position: [0, 22],
      size: [1, 2],
      indicator: 'POSVENTA_DISPONIBILIDAD_TALLER',
      criticalMomentId: 2,
      extraConfigs: {
        maxValue: 5,
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGeneric',
      key: 'posventa-presupuesto',
      title: 'widgets.budgetPostventa',
      helpText: 'widgets.budgetPostventa',
      position: [1, 22],
      size: [1, 2],
      indicator: 'POSVENTA_PRESUPUESTO',
      criticalMomentId: 2,
      extraConfigs: {
        maxValue: 5,
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGeneric',
      key: 'posventa-garantia',
      title: 'widgets.warrantyPostventa',
      helpText: 'widgets.warrantyPostventa',
      position: [2, 22],
      size: [1, 2],
      indicator: 'POSVENTA_GARANTIA',
      criticalMomentId: 2,
      extraConfigs: {
        maxValue: 5,
      },
    })
  ],
} as DasboardConfig
